import { SparkResult } from "ags/integration/model/results/spark-result";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Result } from "appworks/model/gameplay/records/results/result";
import { CurrencyService } from "appworks/services/currency/currency-service";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { State } from "appworks/state-machine/states/state";
import { unique } from "appworks/utils/collection-utils";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Point } from "appworks/utils/geom/point";
import { SymbolFooterComponent } from "slotworks/components/footer/symbol-footer-component";
import { AbstractMatrixComponent, DimType } from "slotworks/components/matrix/abstract-matrix-component";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";

export class AgsHighlightWinsState extends State {
    public onEnter(): void {
        this.highlightWins().then(() => {
            Components.get(MatrixComponent).resetSymbols();
            this.complete();
        });
    }

    protected highlightWins(): Contract<void> {

        const hasNoWins = !gameState.currentRecordHasSymbolWinResults() && !gameState.currentRecordHasBonusWinResults();
        if (hasNoWins) { return Contract.empty(); }

        const winningPositions = this.getWinningSymbolPositions();

        let winningSymbols = [];
        const winningSymbolIDs = [];

        for (const position of winningPositions) {
            const symbol = Components.get(MatrixComponent).getSymbol(position.x, position.y);
            winningSymbols.push(symbol);
            winningSymbolIDs.push(symbol.symbolId);
        }

        winningSymbols = unique(winningSymbols);
        const uniqueWinningSymbolIDs = unique(winningSymbolIDs);

        Services.get(SoundService).event(SoundEvent.highlight_all_wins);
        for (const symbolID of uniqueWinningSymbolIDs) {
            let count = 0;
            for (const symbolToCount of winningSymbolIDs) {
                if (symbolID === symbolToCount) {
                    count++;
                }
            }

            Components.get(AbstractMatrixComponent).playSymbolSound(symbolID, `${count}`, "1")
        }

        const matrix: MatrixComponent = Components.get(MatrixComponent);

        return new Parallel([
            () => matrix.dimSymbols(matrix.getAllSymbols(), DimType.Highlight),
            () => matrix.highlightSymbols(winningSymbols)
        ]);
    }

    protected getWinningSymbolPositions(): Point[] {
        const currentRecord = gameState.getCurrentGame().getCurrentRecord();
        const allWins = currentRecord.results;
        let winningPositions: Point[] = [];

        for (const win of allWins) {
            const symbolWin = win as SymbolWinResult;
            if (this.isCelebratedResult(win)) {
                winningPositions = winningPositions.concat(symbolWin.positions);
            }
        }

        return winningPositions;
    }

    protected isCelebratedResult(win: Result): boolean {
        return win instanceof SymbolWinResult || (win instanceof SparkResult && gameState.currentRecordHasBonusWinResults());
    }
}
